/**
 * External dependencies
 */
import { useEffect, useMemo } from 'react';
import useBrowserHistory from '@naruto/naruto-hooks/src/useBrowserHistory';

/**
 * Internal dependencies
 */
import useReduxApi from '@naruto/bgdcms/src/hooks/useReduxApi';
import useMappedState from '@naruto/bgdcms/src/hooks/useMappedState';

interface UseData {
  /* Data : General */
  showSidebar: boolean;
  userIsLogin: boolean;
}

function useData(): UseData {
  /* Global & Local State */
  const reduxGlobal = useReduxApi('global');
  const storeUser = useMappedState(state => state.user);
  const storeGlobal = useMappedState(state => state.global);

  /* Data */
  const { historyStacks } = useBrowserHistory();
  const showSidebar = useMemo(
    () => storeUser.userIsLogin && storeGlobal.globalSideBarStatic,
    [storeUser.userIsLogin, storeGlobal.globalSideBarStatic]
  );

  /* Hooks */
  useEffect(() => {
    reduxGlobal('postGlobalHistories', [historyStacks]);
  }, [historyStacks]);

  /* Main */
  return {
    /* Data : General */
    showSidebar,
    userIsLogin: storeUser.userIsLogin
  };
}

export default useData;
